"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bit = void 0;
var uom_1 = require("uom");
/**
 * The unit for binary information ( <code>bit</code> ).
 */
exports.Bit = uom_1.Unit.createBase("Bit", "DataAmount", "bit");
//# sourceMappingURL=data-amount.js.map